<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
>
  @if (this.accountMoves) {
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-8 col-md-8">
          <div class="ps-3">
          </div>
        </div>
        <div class="col ms-auto text-end align-self-center">
          @if (accountMoves.length === 300) {
            <i>Résultats limités aux 300 plus récents</i>
          }
        </div>
      </div>
      <div class="row mt-2">
        <table class="table table-striped border-bottom">
          <thead>
          <tr>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_TYPE</a>
            </th>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_CONTRACT_NAME</a>
            </th>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_EMITTER</a>
            </th>
            <th class="text-end">
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_AMOUNT</a>
            </th>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_PERIOD</a>
            </th>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_NAME</a>
            </th>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_BINDED</a>
            </th>
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_STATUS</a>
            </th>
            <!--          <th>-->
            <!--            <a translate>PAYMENT_LBL_ACTIONS</a>-->
            <!--          </th>-->
            <th>
              <a translate>CONTRACT_TABLE_ACCOUNTMOVE_REPAYMENT_BINDED</a>
            </th>
          </tr>
          </thead>

          <tbody>
            @for (accountMove of accountMoves; track accountMove.id) {
              <ng-container class="row-action">
                @for (accountMoveLine of accountMove.accountMoveLines; track accountMoveLine.id) {
                  <tr>
                    <td>{{ accountMove.name }}</td>
                    <td>{{ accountMove.contractName }}</td>
                    <td>{{ accountMove.companyOrBrokerAccountName }}</td>
                    <td class="text-end">
                      <app-colored-amount [amountValue]="accountMoveLine.unitPriceClientView" />
                    </td>
                    <td>
                      {{ accountMove.period | accountMovePeriod }}
                    </td>
                    <td>
                      {{ accountMove.reference }}
                    </td>
                    @if (accountMove.payingAccountMoves.length == 0) {
                      <td>
                        @if (this.isClient) {
                          <a
                            role="button"
                            (click)="
                      openModalBindAccountMoves(accountMove.contractId ? accountMove.contractId : 0,'Entry', accountMove.id )
                    "
                            translate
                          >PAYMENT_LBL_BIND_PAYMENT</a
                          >
                        }
                      </td>
                    }
                    @if (accountMove.payingAccountMoves.length > 0) {
                      <td>
                        @if (this.isClient) {
                          <a
                            role="button"
                            (click)="
                    openModalBindAccountMovesDetails(
                      accountMove,
                      'Payment',
                      accountMove.isReadOnly,
                      accountMove.isAdminOnly
                    )
                  "
                            translate
                          >{{
                              accountMove.payingAccountMoves
                                | showPaymentAndTruncate : [50]
                            }}
                          </a>
                        } @else {
                          <a
                            role="button"
                            (click)="
                    openModalBindAccountMovesDetails(
                      accountMove,
                      'Slip',
                      false,
                      accountMove.isAdminOnly
                    )
                  "
                            translate
                          >{{
                              accountMove.payingAccountMoves
                                | showPaymentAndTruncate : [50]
                            }}
                          </a>
                        }
                      </td>
                    }
                    <td>
                      {{ accountMove.statusLoc }}
                    </td>
                    <!--            <td>-->
                    <!--              <ng-container-->
                    <!--                *ngFor="let action of accountMove.actions; let last = last;"-->
                    <!--              >-->
                    <!--                <a-->
                    <!--                  role="button"-->
                    <!--                  (click)="-->
                    <!--                      this.triggerAction(-->
                    <!--                        action.name,-->
                    <!--                        accountMove.id-->
                    <!--                      )-->
                    <!--                    "-->
                    <!--                  translate-->
                    <!--                >{{ action.actionName }}{{ last ? "" : " | " }}</a-->
                    <!--                >-->
                    <!--              </ng-container>-->
                    <!--            </td>-->
                    @if (accountMove.repaymentAccountMoves.length == 0) {
                      <td>
                        @if (!accountMove.isReadOnly) {
                          <a
                            role="button"
                            (click)="openModalRepaymentBindAccountMoves(accountMove.contractId ? accountMove.contractId : 0, accountMove.id)"
                            translate
                          >REPAYMENT_LBL_BIND_ACCOUNT_MOVE</a
                          >
                        }
                      </td>
                    }
                    @if (accountMove.repaymentAccountMoves.length > 0) {
                      <td>
                        <a
                          role="button"
                          (click)="
                      openModalBindAccountMovesDetails(
                        accountMove,
                        'Repayment',
                        false,
                        accountMove.isAdminOnly
                      )
                    "
                          translate
                        >{{
                            accountMove.repaymentAccountMoves
                              | showRepaymentAndTruncate : [50]
                          }}
                        </a>
                      </td>
                    }
                  </tr>
                }
              </ng-container>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
